<template>
  <div id="app" class="red" style="height: 100%;">
    <div v-show="isLoading">加载中...</div>
    <router-view v-show="!isLoading"/>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      theme: localStorage.theme
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  methods: {
  }
  // created () {
  //   axios
  //     .get('/fair/get-theme?fair_id=' + this.$route.params.id)
  //     .then(res => {
  //       res = res.data
  //       console.log(res)
  //       if (res.status) {
  //         this.theme = res.data
  //         localStorage.theme = this.theme
  //       }
  //     })
  //     .catch()
  // }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/App.vue